import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserMenu from '../../components/menus/UserMenu';
import LogoutButton from '../../components/menus/LogoutButton';
import { logout } from '../../store/actions/auth';
import { fullName } from '../../utils/textHelper';

function UserMenuContainer(props) {
  if (!props.email) {
    return null;
  } else if (props.button) {
    return <LogoutButton logout={props.logout} />;
  } else {
    return <UserMenu {...props} />;
  }
}

const mapStateToProps = (state) => {
  const { user } = state.role;

  if (!user) {
    return {};
  }

  return {
    email: user.email,
    username: fullName(user),
  };
};

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserMenuContainer);

UserMenuContainer.defaultProps = {
  button: false,
};

UserMenuContainer.propTypes = {
  button: PropTypes.bool,
  email: PropTypes.string,
  username: PropTypes.string,
};
